(function() {
'use strict';

angular
    .module('TR')
    .controller('LoadingScreen', LoadingScreen);

function LoadingScreen($scope, resourceService, publicityService, searchUnitService, currentDestination, broker, tripService, $route, funcUtil, $timeout, $rootScope, analytics) {
    const cm = this;
    const properties = { name: resourceService.getDeferred('PROPERTIES'), icon: 'icon-hotels' };
    const reviews = { name: resourceService.getDeferred('HOTELREVIEWS'), icon: 'icon-reviews' };
    const airlines = { name: resourceService.getDeferred('AIRLINES'), icon: 'icon-flights' };

    if (TRPCONFIG.DeviceSettings.PublicityMessagingEnabled) {
        publicityService.getStats({
            CultureCode: TRPCONFIG.Domain.CultureCode,
            StatisticTypes: 'All',
            SearchDate: searchUnitService.startDate(searchUnitService.flight) || searchUnitService.startDate(searchUnitService.hotel)
        }).then(function(data) {
            cm.stats = data;
            properties.count = data.EstabCount;
            reviews.count = data.ReviewCount;
            airlines.count = data.AirlineCount;
        });
    }

    $scope.$watch('searching', function(v) {
        if (v) {
            currentDestination.getCurrentDestination().then(function(dest) {
                cm.destination = dest;
                TRPCONFIG.searchState = 'searching';
            });
        }
        TRPCONFIG.searchState = 'resultloaded';
    });

    broker.subscribe('LoadingScreen', 'tripUpdated', function(trip) {
        (trip.data.TripId ? tripService.getTripDestination(trip.data.TripId)
                          : currentDestination.getCurrentDestination())
            .then(dest => cm.destination = dest);
    });

    $scope.$on('$destroy', () => {
        broker.unsubscribe('LoadingScreen');
    });

    cm.chooseStyles = loadingScreenStyle => {
        if (TRPCONFIG.DeviceSettings.PublicityMessagingEnabled) {
            if (window.logLoadingScreenStyle) {
                console.log('loadingScreenStyle: ', loadingScreenStyle);
            }

            const strippedloadingScreenStyle = (loadingScreenStyle || '').split('-')[0];

            switch (strippedloadingScreenStyle) {
                case 'booking':
                    cm.showBookMessage = true;
                    cm.scalemessages = [];
                    if (!cm.usp) {
                        cm.usp = ['USPHOLIDAYDEPOSIT', 'USPFLEXIBLEPAYMENT', 'USPLOWESTPRICES'];
                    }
                    break;
                case 'hotels':
                    cm.showBookMessage = false;
                    cm.scalemessages = [properties, reviews];
                    cm.usp = ['USPDEPOSIT', 'USPFLEXIBLEPAYMENT', 'USPLOWESTPRICES'];
                    break;
                case 'flights':
                    cm.showBookMessage = false;
                    cm.scalemessages = [airlines];
                    cm.usp = ['USPLOWESTPRICES'];
                    break;
                default:
                    cm.showBookMessage = false;
                    cm.scalemessages = [properties, reviews, airlines];
                    cm.usp = ['USPHOLIDAYDEPOSIT', 'USPFLEXIBLEPAYMENT', 'USPLOWESTPRICES'];
                    break;
            }
        }
    };

    $timeout(() => {
        const area = $route.current && $route.current.$$route && $route.current.$$route.area;
        cm.chooseStyles(`${area}-loadingScreenCtrl`);
    });

    let windowPrerenderReadyTrue = _.debounce(() => window.prerenderReady = true, 1000);
    let key = 'timer';
    let scrollTimeout;

    $rootScope.$on('block', function(ev, data) {
        window.prerenderReady = false;
        analytics.endTimer(key);
        scrollTimeout = $timeout(function() {
        // This will be cancelled if unblock runs immediately
            // Avoids scroll during form validation
            scrollTo(0, 0);
        });
        $scope.title = data.title;
        $scope.subtitle = data.subtitle;

        $rootScope.searching = true;
        $scope.searching = true;

        if ($scope.cm && $scope.cm.chooseStyles) {
            $scope.cm.chooseStyles(data.loadingScreenStyle);
        }
        key = $scope.title || 'timer';
        analytics.startTimer(key);
    });

    function unblock() {
        windowPrerenderReadyTrue();
        $rootScope.searching = false;
        $scope.searching = false;
        $timeout.cancel(scrollTimeout);
        analytics.endTimer(key);
    }
    $rootScope.$on('unblock', unblock);
    broker.subscribe('LoadingScreenDirective', 'unblock', unblock);
    $scope.$on('$destroy', () => broker.unsubscribe('LoadingScreenDirective'));
}
})();
